import React, { useEffect, useState } from 'react';

import FeaturedArticle from '@components/FeedItems/FeaturedArticle';
import Spinner from '@components/Spinner';
import type { Article } from '@interfaces/homepage';
import { getUserRecommendedArticles } from '@utils/backend-api/articles';

import MyTISection from './Section';

const MyTIRecommendedArticles = () => {
  const [articles, setArticles] = useState<Article[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;

    const fetchArticles = async () => {
      try {
        const results = await getUserRecommendedArticles();
        if (!cancelled) setArticles(results);
      } finally {
        if (!cancelled) setIsLoading(false);
      }
    };

    fetchArticles();

    return () => {
      cancelled = true;
    };
  }, []);

  if (!isLoading && articles.length === 0) return null;

  return (
    <MyTISection
      highlight="Label"
      subtitle="Lorem ipsum dolor sit amet consectetur adipisicing elit. Quisquam, quos."
      title="Recommended Articles"
    >
      {isLoading ? (
        <Spinner marginY="small" />
      ) : (
        <div className="mt-32 flex flex-col gap-32 md:flex-row md:gap-112">
          {articles.map((article) => (
            <FeaturedArticle
              key={article.id}
              className="!border-0 !pb-0"
              featuredArticle={article}
              isFluid
            />
          ))}
        </div>
      )}
    </MyTISection>
  );
};

export default MyTIRecommendedArticles;
